// extracted by mini-css-extract-plugin
export default {"feature-block":"style_feature-block__uWq2u","feature-block-content":"style_feature-block-content__1VRWN"};